var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge",class:_vm.cssclass},[_vm._v(_vm._s(_vm._f("titlecase")(_vm._f("t")(_vm.status))))])
}
var staticRenderFns = []

export { render, staticRenderFns }